
import {
    GET_USERS, IS_LOADING_GET_USERS
} from './types'
import inMemoryJWT from '../auth/inMemoryJwt';
import { urlServer } from '../config/GlobalConstant'

export const getUsers = (history) => async dispatch => {

     
    
      

    await fetch(`${urlServer}users/get-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJWT.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }
    })
        .then(response => response.json())
        .then(respJson => {
            dispatch({
                type: IS_LOADING_GET_USERS
            });
            console.log()
            dispatch({
                type: GET_USERS,
                payload: respJson
            });
        })
        .catch(error => {
            console.log()
        })

}